import lenis from './lenis.js';

/**
 * モーダル
 */

jQuery( function ($) {

  const body = $( 'body' );
  const focusTrap = $( '.js-focus-trap' )
  const closeButton = $( '.js-modal-close' );
  const modal = $( '.js-modal' );

  modal.on( 'wheel touchmove' ,(e) => {
    e.stopPropagation()
  })

	$( '.js-modal-button' ).on( 'click', function() {
		const modalId = $(this).data('modal-id');
    const modal = $( '#' + modalId );
    if ( modal.hasClass( 'is-active' ) ) {
      closeModal( modal );
    } else {
      openModal( modal );
    }
	} );

  closeButton.on( 'click', function() {
    const modal = $( this ).closest( '.js-modal' );
    closeModal( modal );
  } );

  const openModal = ( modal ) => {
    modal.addClass( 'is-active' ).focus();
    lenis.stop();
  }

  const closeModal = ( modal ) => {
    modal.removeClass( 'is-active' ).blur();
    lenis.start();
  }

  // フォーカストラップ制御
  focusTrap.on( 'focus', function() {
    $( this ).closest( '.js-modal' ).find( '.js-modal-close' ).focus();
  } );

  // コーディネートのモーダルをリサイズ時に調整
  const filterModal = $( '.p-filter .js-modal');
  let flag;
  if ( window.matchMedia('(min-width: 1152px)').matches ) {
    flag = 'pc';
  } else {
    flag = 'sp';
  }
  $( window ).on( 'resize', function () {
    if ( window.matchMedia( '( min-width: 1152px )' ).matches && flag !== 'pc') {
      filterModal.removeAttr( 'style' ).removeClass( 'is-active' );
      if ( $('.js-drawer').attr('aria-hidden') == 'true' ) {
        lenis.start();
      }
      flag = 'pc';
    } else if ( flag !== 'sp' ) {
      flag = 'sp';
    }
  });

} );

